import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] bg-gradient-to-b from-turquoise to-deepBlue flex flex-col items-center pt-2 pb-20 px-4 overflow-hidden" data-id="element-92">
      {/* Subtle violet glow in upper corners */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-softViolet/30 rounded-full blur-[100px] -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-93" />
      <div className="absolute top-0 right-0 w-96 h-96 bg-softViolet/30 rounded-full blur-[100px] translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-94" />

      <div className="max-w-5xl mx-auto w-full flex flex-col items-center text-center z-10" data-id="element-95">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl lg:text-6xl font-bold text-white -mb-2 leading-tight max-w-4xl" data-id="element-96">
          Dominá tu cursada universitaria{' '}
          <span className="text-goldenYellow" data-id="element-97">sin estrés</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: [0, -8, 0]
      }} transition={{
        opacity: {
          duration: 0.6,
          delay: 0.2
        },
        scale: {
          duration: 0.6,
          delay: 0.2
        },
        y: {
          duration: 3,
          delay: 0.8,
          repeat: Infinity,
          repeatType: 'loop',
          ease: 'easeInOut'
        }
      }} className="relative w-full max-w-[300px] mx-auto mb-6" data-id="element-98">
          <img src="https://cdn.magicpatterns.com/uploads/sSjd3ukv6yzp3LAEnApJjR/ChatGPT_Image_9_mar_2026,_08_02_36_p.m..png" alt="MegaPack Cursada Sin Estrés" className="w-full h-auto object-contain drop-shadow-2xl rounded-2xl" data-id="element-99" />
          <motion.div animate={{
          scale: [1, 1.08, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: 'loop',
          ease: 'easeInOut'
        }} className="absolute -bottom-2 -right-2 md:bottom-3 md:right-3 bg-coralOrange text-white font-bold text-sm md:text-base w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full shadow-xl rotate-[-5deg] border-4 border-white" data-id="element-100">
            50% OFF
          </motion.div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-base md:text-lg text-white/80 max-w-2xl mb-10 leading-relaxed font-medium" data-id="element-101">
          Organizá tus materias, parciales y entregas con un método claro,
          simple y probado. Todo listo para usar desde el primer día.
        </motion.p>

        <motion.a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9hJcYAJ6aX5aJ3wBC1CQj/es-ar?_r=AQAB8bH0zu89K7bsPll58nLRDWhvvq0TO43BcpK3J-clHp8&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} whileHover={{
        scale: 1.05,
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }} whileTap={{
        scale: 0.98
      }} className="bg-goldenYellow text-deepBlue font-bold text-xl md:text-2xl px-10 py-5 rounded-full shadow-lg transition-all duration-300 mb-4 w-full md:w-auto inline-block text-center no-underline" data-id="element-102">
          ¡Quiero el MegaPack ahora! →
        </motion.a>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="flex items-center gap-4 text-sm md:text-base text-white/70 font-medium" data-id="element-103">
          <span className="flex items-center gap-1" data-id="element-104">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-105" /> Pago seguro con Mercado Pago
          </span>
          <span data-id="element-106">|</span>
          <span className="flex items-center gap-1" data-id="element-107">
            <ZapIcon className="w-4 h-4" data-id="element-108" /> Acceso inmediato
          </span>
        </motion.div>
      </div>
    </section>;
}